import CloseIcon from "@mui/icons-material/Close"
import _Dialog, { type DialogProps } from "@mui/material/Dialog"
import _DialogActions from "@mui/material/DialogActions"
import _DialogContent from "@mui/material/DialogContent"
import _DialogContentText from "@mui/material/DialogContentText"
import _DialogTitle from "@mui/material/DialogTitle"
import type { ReactNode } from "react"
import { IconButton } from "./Button"

export const Dialog = _Dialog
export const DialogActions = _DialogActions
export const DialogContent = _DialogContent
export const DialogContentText = _DialogContentText
export const DialogTitle = _DialogTitle

export type DialogComponentProps = Omit<DialogProps, "title" | "onClose"> & {
	title: ReactNode
	onClose: () => void
}
export const DialogComponent = ({ title, children, onClose, ...props }: DialogComponentProps) => (
	<Dialog {...props} onClose={onClose}>
		<IconButton
			onClick={onClose}
			sx={(theme) => ({
				zIndex: 1,
				position: "absolute",
				right: 8,
				top: 8,
				color: theme.palette.grey[500],
			})}
		>
			<CloseIcon />
		</IconButton>
		<DialogTitle>{title}</DialogTitle>
		{children}
	</Dialog>
)
